import React, { useState, useEffect } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import Swal from "sweetalert2";
import CompanyNavbar from "../company/CompanyNavbar";
import url from "../../function/url";
import "../company/formstyle.css";

const AssignWork = () => {
    const [formData, setFormData] = useState({
        employee: "",
        task: "",
        description: "",
        start_date: new Date().toISOString().split("T")[0],
        due_date: "",
        document: null,

    });
    const ID = Cookies.get("log_id"); // Logged-in user ID from cookies
    

    const [employees, setEmployees] = useState([]);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const logId = Cookies.get("log_id");
        if (!logId) {
            setError("User not logged in or session expired. Please log in again.");
            setLoading(false);
            return;
        }

        axios
            .get(`${url.path}/employees/`, {
                params: { log_id: logId },
                headers: { "X-CSRFToken": Cookies.get("csrftoken") },
            })
            .then((response) => {
                setEmployees(response.data);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching employees:", error);
                
                setLoading(false);
            });
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
        setError("");
    };

    const handleFileChange = (e) => {
        setFormData((prev) => ({ ...prev, document: e.target.files[0] }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        if (!formData.employee || !formData.task || !formData.due_date) {
            setError("Employee, Task, and Due Date are required.");
            return;
        }
    
        const logId = Cookies.get("log_id"); // Fetch login ID from cookies
    
        if (!logId) {
            setError("User session expired. Please log in again.");
            return;
        }
    
        const formDataObj = new FormData();
        const updatedFormData = { ...formData, login: logId }; // Include login ID
    
        Object.keys(updatedFormData).forEach((key) => {
            if (updatedFormData[key]) formDataObj.append(key, updatedFormData[key]); // Avoid appending null values
        });
    
        try {
            const payload = {
                employee: formData.employee,
                task: formData.task,
                description: formData.description,
                start_date:formData.start_date,
                due_date:formData.due_date,
                document:formData.document,
                login: ID,
            };
            console.log("Payload being sent:", payload);
            await axios.post(`${url.path}/assignwork/`, payload, {
                headers: { "Content-Type": "multipart/form-data" },
            });
    
            Swal.fire("Success", "Work assigned successfully!", "success");
    
            setFormData({
                employee: "",
                task: "",
                description: "",
                start_date: new Date().toISOString().split("T")[0],
                due_date: "",
                document: null,
            });
        } catch (err) {
            Swal.fire("Error", "Failed to assign work. Try again.", "error");
        }
    };
    
    return (
        <>
            <CompanyNavbar />
            <div className="page-wrapper">
                <div className="form-container">
                    <h1 className="text-2xl font-bold mb-4">Assign Work</h1>
                    {error && <p className="text-red-500">{error}</p>}

                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div>
                            <label className="block font-medium mb-1">Select Employee</label>
                            {loading ? (
                                <p>Loading employees...</p>
                            ) : (
                                <select
                                    name="employee"
                                    value={formData.employee}
                                    onChange={handleChange}
                                    required
                                    className="w-full border rounded p-2"
                                >
                                    <option value="">Select Employee</option>
                                    {employees.map((emp) => (
                                        <option key={emp.id} value={emp.id}>
                                            {emp.Employee_Name}
                                        </option>
                                    ))}
                                </select>
                            )}
                        </div>

                        <input
                            type="text"
                            name="task"
                            value={formData.task}
                            onChange={handleChange}
                            placeholder="Task"
                            className="w-full border rounded p-2"
                            required
                        />
                        <textarea
                            name="description"
                            value={formData.description}
                            onChange={handleChange}
                            placeholder="Description"
                            className="w-full border rounded p-2"
                        ></textarea>

                        <div>
                            <label className="block font-medium mb-1">Start Date</label>
                            <input
                                type="date"
                                name="start_date"
                                value={formData.start_date}
                                onChange={handleChange}
                                className="w-full border rounded p-2"
                                required
                            />
                        </div>

                        <div>
                            <label className="block font-medium mb-1">Due Date</label>
                            <input
                                type="date"
                                name="due_date"
                                value={formData.due_date}
                                onChange={handleChange}
                                className="w-full border rounded p-2"
                                required
                            />
                        </div>

                        <div className="w-full">
    <label className="block font-medium mb-1">Attach File</label>
    <input 
        type="file" 
        id="image"  
        name="file" 
        onChange={handleFileChange}  
        className="w-full border rounded p-2 bg-white" 
    />
</div>

                        <button type="submit" className="px-4 py-2 bg-blue-500 text-white rounded">
                            Assign
                        </button>
                    </form>
                </div>
            </div>
        </>
    );
};

export default AssignWork;
